<template lang="html">
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <StandardEditBtn class="pull-right" :el="on" @editClick="editActivator()" />
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>TAKT.package Editor</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="10" align="center" justify="center">
            <v-alert type="info">
              All changes apply instantly and are saved immediately.
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
      <v-card class="mb-12 pa-2" color="color-3" min-height="200px">
        <v-row>
          <v-col md="3" sm="6" xs="12">
            <div style="height: 400px; width: 100%;">
              <WaggonInfo :waggon="{}">
                <template #header>
                  <WaggonInfoHeader
                    :width="'100%'"
                    :color="work_package.color"
                    :text="work_package.token"
                    :icon="work_package.icon"
                    />
                </template>
                <template #body>
                  <WaggonInfoBody
                    :color="work_package.color"
                    :work_package="work_package"
                    :info_box="true"
                    >
                    <template #body-content="body_slot">
                      <StandardDataField
                        :value="body_slot.work_package.name"
                        @changeValue="updateWP('name', $event)"
                        />
                      <StandardDataField
                        :value="body_slot.work_package.description"
                        flat="true"
                        placeholder="description"
                        :resizable="true"
                        @changeValue="updateWP('description', $event)"
                        />
                      <v-divider color="black"></v-divider>
                        <StandardFlexBox>
                          <!-- attributes planned -->
                          <StandardFlexBox
                            class="pa-1"
                            width="50%"
                            direction="column"
                            >
                            attributes planned
                            <StandardFlexBox>
                              <StandardDataField
                              :value="body_slot.work_package.time_effort_planned"
                              icon="speed"
                              width="28%"
                              :type="'number'"
                              @changeValue="updateWP('time_effort_planned', parseInt($event))"
                              />
                              <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_planned"
                                icon="accessibility"
                                width="28%"
                                :type="'number'"
                                @changeValue="updateWP('manpower_planned', parseInt($event))"
                                />
                              <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_planned === 0 || isNaN(Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100)?
                                        '':Math.round((body_slot.work_package.time_effort_planned/body_slot.work_package.manpower_planned)*100) / 100"
                                icon="timer"
                                width="28%"
                                :readonly="true"
                                />
                            </StandardFlexBox>
                            <StandardFlexBox>
                              <StandardDataField
                                :value="body_slot.work_package.quantity_value"
                                icon="drag_indicator"
                                width="33%"
                                :type="'number'"
                                @changeValue="updateWP('quantity_value', parseInt($event))"
                                />
                              <StandardDataField
                                :value="body_slot.work_package.quantity_unit"
                                icon="drag_indicator"
                                width="33%"
                                @changeValue="updateWP('quantity_unit', $event)"
                                />
                            </StandardFlexBox>
                          </StandardFlexBox>
                          <!-- attributes actual -->
                          <StandardFlexBox
                            style="border-left: solid 1px black"
                            class="pa-1"
                            width="50%"
                            direction="column"
                            >
                            attributes actual
                            <StandardFlexBox>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_actual === 0?
                                        '':Math.round((body_slot.work_package.duration_actual*body_slot.work_package.manpower_actual)*100) / 100"
                                icon="speed"
                                icon_actual="true"
                                width="28%"
                                :readonly="true"
                                />
                              <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
                              <StandardDataField
                                :value="body_slot.work_package.manpower_actual"
                                icon="accessibility"
                                icon_actual="true"
                                width="28%"
                                :type="'number'"
                                :readonly="true"
                                />
                              <div style="width: 8%; line-height: 33px; text-align: center;">x</div>
                              <StandardDataField
                                :value="body_slot.work_package.duration_actual"
                                icon="timer"
                                icon_actual="true"
                                width="28%"
                                :type="'number'"
                                :readonly="true"
                                />
                            </StandardFlexBox>
                          </StandardFlexBox>
                        </StandardFlexBox>
                      <v-divider color="black"></v-divider>
                      <!-- Contact -->
                      <StandardFlexBox
                        direction="column"
                        :no_wrap="true"
                        >
                        contact
                        <StandardDataField
                          width="100%"
                          :value="body_slot.work_package.contact_name"
                          icon="account_circle"
                          readonly
                          @changeValue="updateWP('contact_name', $event)"
                          />
                        <StandardDataField
                          width="100%"
                          :value="body_slot.work_package.contact_phone_number"
                          icon="call"
                          readonly
                          @changeValue="updateWP('contact_phone_number', $event)"
                          />
                        <StandardDataField
                          width="100%"
                          :value="body_slot.work_package.contact_email"
                          icon="email"
                          readonly
                          @changeValue="updateWP('contact_email', $event)"
                          />
                        </StandardFlexBox>
                    </template>
                  </WaggonInfoBody>
                </template>
              </WaggonInfo>
            </div>
          </v-col>
          <v-col md="3" sm="6" xs="12">
            <div style="height: 400px; width: 100%;">
              <WaggonInfo :waggon="{}">
                <template #header>
                  <WaggonInfoHeader
                    :width="'100%'"
                    :color="work_package.color"
                    :text="work_package.token"
                    :icon="work_package.icon"
                    />
                </template>
                <template #body>
                  <WaggonInfoBody
                  :color="work_package.color"
                  :work_package="work_package"
                  :info_box="true"
                  >
                  <template #body-content="body_slot">
                    WORK.steps ({{body_slot.work_package.work_steps.length}})
                    <draggable
                    :value="work_package.work_steps"
                    @change="pushWWorkStep($event)"
                    v-bind="work_step_draggable">
                      <StandardStep
                        v-for="(work_step) in body_slot.work_package.work_steps"
                        :key="'work_step' + work_step.id"
                        :step="work_step"
                        :readonly="true"
                        step_type="worksteps"
                      />
                    </draggable>
                  </template>
                </WaggonInfoBody>
                </template>
              </WaggonInfo>
            </div>
          </v-col>
          <v-col md="3" sm="6" xs="12">
            <div style="height: 400px; width: 100%;">
              <WaggonInfo :waggon="{}">
                <template #header>
                  <WaggonInfoHeader
                    :width="'100%'"
                    :color="work_package.color"
                    :text="work_package.token"
                    :icon="work_package.icon"
                    />
                </template>
                <template #body>
                  <WaggonInfoBody
                  :color="work_package.color"
                  :work_package="work_package"
                  :info_box="true"
                  >
                  <template #body-content="body_slot">
                    QUALITY.steps ({{body_slot.work_package.quality_steps.length}})
                    <StandardStep
                      v-for="(quality_step) in body_slot.work_package.quality_steps"
                      :key="'quality_step' + quality_step.id"
                      :step="quality_step"
                      :readonly="true"
                      step_type="qualitysteps"
                    />
                  </template>
                </WaggonInfoBody>
                </template>
              </WaggonInfo>
            </div>
          </v-col>
          <v-col md="3" sm="6" xs="12">
            <div style="height: 400px; width: 100%;">
              <WaggonInfo :waggon="{}">
                <template #header>
                  <WaggonInfoHeader
                    :width="'100%'"
                    :color="work_package.color"
                    :text="work_package.token"
                    :icon="work_package.icon"
                    />
                </template>
                <template #body>
                  <WaggonInfoBody
                  :color="work_package.color"
                  :work_package="work_package"
                  :info_box="true"
                  >
                  <template #body-content="body_slot">
                    DEFECT.steps ({{body_slot.work_package.defect_steps.length}})
                    <StandardStep
                      v-for="(defect_step) in body_slot.work_package.defect_steps"
                      :key="'defect_step' + defect_step.id"
                      :step="defect_step"
                      :readonly="true"
                      step_type="defectsteps"
                    />
                  </template>
                </WaggonInfoBody>
                </template>
              </WaggonInfo>
            </div>
          </v-col>
        </v-row>
        <h2>Pick Icon and Color</h2>
        <h3>Icons</h3>
        <v-chip
          v-for="icon in work_package_icons" :key="icon"
          class="ma-1"
          color="grey lighten-1" label @click="updateWP('icon', icon)"
          >
          <svg-icon :name="`${icon}`" :size="25" style="color: black;"></svg-icon>
        </v-chip>
        <div class="mt-5 clear"></div>
        <h3>Colors</h3>
        <v-card class="picker-card" v-for="color in work_package_colors"
                :key="color" :color="color"
                @click="updateWP('color', color)"
                >
        </v-card>
        <div class="mt-5 clear"></div>
        <h3>Text Colors</h3>
        <v-card class="picker-card" v-for="color in work_package_colors"
                :key="'text'+color" :color="color"
                @click="updateWP('textcolor', color)"
                >
        </v-card>
        <div class="mt-5 clear"></div>

        <h2>Finalize TAKT.package</h2>
        <StandardFlagDropdown
        :value="getCountryName(work_package.country)"
        color="secondary"
        :options="countries"
        @changeValue="updateWPCountry($event)" />
        <StandardTextfield class="mt-5" color="secondary" placeholder="Hashtags"
                           type="text" min="1" style="width: 50%"
                           :value="getWorkPackageHashtags" @changeValue="updateHashtags($event)" />

      </v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Done editing</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { InfoBoxMixin} from '@/mixins/InfoBox.mixin.js';
import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js';

import draggable from "vuedraggable"
import {
  mapActions
} from 'vuex';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue';
import StandardFlagDropdown from '@/components/StandardComponents/StandardFlagDropdown.component.vue';
import StandardEditBtn from '@/components/StandardComponents/StandardEditBtn.component.vue'

import {
  getCountries,
  getWorkPackageColors,
  getWorkPackageIcons
} from '../../helpers/data';


export default {
  name: 'WorkPackageUpdateEditorDialog',
  props: ['work_package'],
  components: {
    StandardEditBtn,
    StandardTextfield,
    StandardFlagDropdown,
    draggable
  },
  mixins: [InfoBoxMixin, WaggonInfoMixin],
  data: () => ({
    dialog: false,
    e1: 1,
    countries: [],
    work_package_colors: [],
    work_package_icons: [],
    work_step_draggable: {
      group: {
        name: 'draggable_wwork_steps',
        pull: true,
        put: true
      }
    }
  }),
  computed: {
    getWorkPackageHashtags: function() {
      const hashtags = [];
      for (var i = 0; i < this.work_package.hashtags.length; i++) {
        hashtags.push(this.work_package.hashtags[i].tag);
      }
      return hashtags.join(' ');
    }
  },
  methods: {
    editActivator() {
      this.countries = getCountries();
      this.work_package_colors = getWorkPackageColors();
      this.work_package_icons = getWorkPackageIcons();
      this.countries.push({
        flag: 'other',
        name: 'Other'
      });
      this.dialog = true;
    },
    getCountryName(flag){
      const country = this.countries.find(c => c.flag === flag);
      if (country) {
        return country.name;
      }
      return 'n/a';
    },
    updateHashtags(hashtags) {
      let hashtag_arr = hashtags.split(' ');
      for (var i = 0; i < hashtag_arr.length; i++) {
        if (hashtag_arr[i].startsWith('#')) {
          hashtag_arr[i] = hashtag_arr[i].substr(1);
        }
      }
      this.updateWorkPackageHashtags({
        work_package_id: this.work_package.id,
        update: {hashtags: hashtag_arr}
      });
    },
    updateWP(target, val){
      this.updateWorkPackage({
        work_package_id: this.work_package.id,
        update: {
          [target]: val
        }
      });
    },
    updateWWorkStep(text, work_step){
      this.updateWorkPackageWWorkStep({
        work_package_id: this.work_package.id,
        wwork_step_id: work_step.id,
        update: {
          text: text
        }
      });
    },
    updateWPCountry(country){
      this.updateWorkPackage({
        work_package_id: this.work_package.id,
        update: {
          country: country.flag
        }
      });
    },
    updateWPTextColor(textcolor){
      this.updateWorkPackage({
        work_package_id: this.work_package.id,
        update: {
          textcolor: textcolor
        }
      });
    },
    pushWWorkStep(event){
      this.updateWorkPackageWWorkStepPushPosition({
        work_package_id: this.work_package.id,
        wwork_step_id: this.work_package.work_steps[event.moved.oldIndex].id,
        update: {
          work_step: this.work_package.work_steps[event.moved.newIndex].id
        }
      });
    },
    ...mapActions('WorkPackage', [
      'updateWorkPackage',
      'updateWorkPackageHashtags',
      'updateWorkPackageWWorkStepPushPosition',
      'updateWorkPackageWWorkStep'
    ])
  }
}
</script>

<style lang="css" scoped>
.picker-card {
  width: 58px;
  height: 38px;
  float: left;
  margin: 5px;
  cursor: pointer;
}
</style>
